import { FontWeights } from '@newcore/ui/enums/font-weights';
import { TextSizes } from '@newcore/ui/enums/typography-text-sizes';
import { Text } from '@newcore/ui/typography';
import { initials } from '../utils';

interface ConsentUserRowProps {
  userName: string;
  userEmail: string;
  disabled: boolean;
  onSwitch: () => void;
}

export function ConsentUserRow({
  userName,
  userEmail,
  disabled,
  onSwitch,
}: ConsentUserRowProps) {
  return (
    <div className='flex items-center gap-2 w-[352px] max-w-full py-2 pl-2.5 pr-3 bg-secondary rounded-lg'>
      <Text
        as='div'
        size={TextSizes.XS}
        weight={FontWeights.SEMIBOLD}
        className='flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-brand-solid leading-[18px] text-primary_on-brand'
      >
        {initials(userName)}
      </Text>
      <Text
        size={TextSizes.SM}
        weight={FontWeights.MEDIUM}
        className='flex-1 truncate leading-5 text-primary'
        data-testid='consent-user-email'
      >
        {userEmail}
      </Text>
      <button
        type='button'
        className='group flex-shrink-0 disabled:opacity-50'
        onClick={onSwitch}
        disabled={disabled}
        data-testid='consent-switch-user'
      >
        <Text
          size={TextSizes.XS}
          weight={FontWeights.REGULAR}
          className='leading-[18px] text-secondary group-hover:text-primary'
        >
          Not you?
        </Text>
      </button>
    </div>
  );
}
